<script>
import { AgGridVue } from 'ag-grid-vue'
import AG_GRID_LOCALE_FR from '@/assets/ag-grid.locale.fr.json'
import AvatarCellRenderer from './AvatarCellRenderer.vue'
import BooleanCellRenderer from './BooleanCellRenderer.vue'
import BooleanFilterCellRenderer from './BooleanFilterCellRenderer.vue'
import ImageCellRenderer from './ImageCellRenderer.vue'
import RatingCellRenderer from './RatingCellRenderer.vue'
import TagCellRenderer from './TagCellRenderer.vue'
import TagFilterCellRenderer from './TagFilterCellRenderer.vue'
import FilesCellRenderer from './FilesCellRenderer.vue'
import IconCellRenderer from './IconCellRenderer.vue'
import DateCellRenderer from './DateCellRenderer.vue'
import ArrayCellRenderer from './ArrayCellRenderer.vue'
import TotalRowCountStatusBar from '../../pages/Users/TotalRowCountStatusBar.vue'
import DisplayedRowCountStatusBar from './DisplayedRowCountStatusBar.vue'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    AvatarCellRenderer, //eslint-disable-line
    BooleanCellRenderer, // eslint-disable-line
    BooleanFilterCellRenderer, // eslint-disable-line
    ImageCellRenderer, // eslint-disable-line
    RatingCellRenderer, //eslint-disable-line
    TagCellRenderer, // eslint-disable-line
    TagFilterCellRenderer, // eslint-disable-line
    FilesCellRenderer, // eslint-disable-line
    IconCellRenderer, // eslint-disable-line
    DateCellRenderer, // eslint-disable-line
    ArrayCellRenderer, // eslint-disable-line
    TotalRowCountStatusBar, // eslint-disable-line
    DisplayedRowCountStatusBar // eslint-disable-line
  },
  props: [
    'options',
    'gridData',
    'showAllDetails',
    'statusBarType'
  ],
  data () {
    return {
      loading: false,
      gridApi: null,
      columnApi: null,
      gridOptions: null,
      gridOptionsDefault: {
        rowModelType: 'clientSide',
        localeText: AG_GRID_LOCALE_FR,
        columnDefs: [],
        defaultColDef: {
          resizable: true,
          floatingFilter: true
        },
        statusBar: {},
        frameworkComponents: {
          DisplayedRowCountStatusBar: DisplayedRowCountStatusBar,
          TotalRowCountStatusBar: TotalRowCountStatusBar
        },
        columnTypes: {
          dateColumnFilterable: {
            headerName: 'Date',
            filter: 'agDateColumnFilter',
            filterParams: {
              maxNumConditions: 1,
              comparator: (filterLocalDateAtMidnight, cellValue) => {
                const cellDate = new Date(cellValue).setHours(0, 0, 0, 0)
                filterLocalDateAtMidnight.setHours(0, 0, 0, 0)

                if (cellDate < filterLocalDateAtMidnight) {
                  return -1
                } else if (cellDate > filterLocalDateAtMidnight) {
                  return 1
                }
                return 0
              }
            }
          }
        }
      }
    }
  },
  watch: {
    gridData: {
      handler () {
        if (this.gridApi) {
          this.gridApi.redrawRows()
        }
      },
      deep: true
    },
    'options.columnDefs': {
      handler () {
        if (this.gridOptions && this.gridOptions.api) {
          this.gridOptions.api.setColumnDefs(this.options.columnDefs)
        }
        if (this.gridApi) {
          this.gridApi.sizeColumnsToFit()
        }
      }
    }
  },
  beforeDestroy () {
    this.gridApi = null
    window.removeEventListener('resize', this.fitColumns)
  },
  created () {
    let statusPanelConfig
    if (this.statusBarType === 'displayed') {
      statusPanelConfig = {
        statusPanels: [
          { statusPanel: 'DisplayedRowCountStatusBar', align: 'left' }
        ]
      }
    } else if (this.statusBarType === 'total') {
      statusPanelConfig = {
        statusPanels: [
          { statusPanel: 'TotalRowCountStatusBar', align: 'left' }
        ]
      }
    } else {
      statusPanelConfig = {
        statusPanels: [
          { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' }
        ]
      }
    }
    this.gridOptions = {
      ...this.gridOptionsDefault,
      ...this.options,
      statusBar: statusPanelConfig
    }
  },
  methods: {
    fitColumns () {
      this.gridApi.sizeColumnsToFit()
    },
    onGridReady (params) {
      this.gridApi = params.api
      this.columnApi = params.columnApi
      window.addEventListener('resize', this.fitColumns)
      this.$emit('gridReady', params)
    },
    onFirstDataRendered (params) {
      // this.columnApi.autoSizeAllColumns()
      this.gridApi.sizeColumnsToFit()
      if (this.gridApi && this.showAllDetails) {
        this.gridApi.forEachNode(node => {
          node.setExpanded(true)
        })
      }
    }
  }
}
</script>

<template>
  <ag-grid-vue
    style="height: 65vh;"
    class="ag-theme-balham w-full px-2"
    :gridOptions="gridOptions"
    :rowData="gridData"
    @grid-ready="onGridReady"
    @first-data-rendered="onFirstDataRendered"
    @selectionChanged="$emit('selectionChanged', gridApi.getSelectedRows())"
    @rowDoubleClicked="$event => $emit('rowDoubleClicked', $event)"
  />
</template>
